import React, { useEffect, useRef } from 'react';
import { Control, useWatch } from 'react-hook-form';

import { SubmitSourceFilesToTaskFormData } from '../../../../forms/SubmitSourceFilesToTaskForm/SubmitSourceFilesToTaskForm.types';
import { TaskSourceFilesFields } from '../../../../../tasksTypes';

import { Translate } from '../../../../../../../helpers/Translate';

import { words } from '../../../../../../../locales/keys';

interface UploadedCounterProps {
  allFiles: number;
  loadingFiles: number;
  handleSubmit: () => void;
  control: Control<SubmitSourceFilesToTaskFormData>;
}

function UploadedCounter({
  allFiles,
  loadingFiles,
  handleSubmit,
  control
}: UploadedCounterProps) {
  const watchAutoSubmit = useWatch({
    control,
    name: TaskSourceFilesFields.AUTO_SUBMIT
  });

  const isSubmittedRef = useRef(false);

  useEffect(() => {
    if (loadingFiles > 0) {
      isSubmittedRef.current = false;
    }
  }, [loadingFiles]);

  useEffect(() => {
    if (
      watchAutoSubmit &&
      allFiles > 0 &&
      loadingFiles === 0 &&
      !isSubmittedRef.current
    ) {
      isSubmittedRef.current = true;
      handleSubmit();
    }
  }, [watchAutoSubmit, allFiles, loadingFiles, handleSubmit]);

  if (allFiles <= 0) {
    return null;
  }

  return (
    <div className="flex justify-center items-center px-4">
      <div className="text-sm bg-white dark:bg-gray-850">
        <Translate id={words.uploaded} />
        <span className="ml-1 px-1 py-0.5 bg-gray-200 dark:bg-gray-700 rounded-md">
          {allFiles - loadingFiles}/{allFiles}
        </span>
      </div>
    </div>
  );
}

export default UploadedCounter;
